import React, { useEffect, useRef, useState } from 'react';
import "./UMAHospital.css";
import ImagePaths from '../../../Utility/ImagePaths';
import { get, post } from '../../../Utility/RestAPIService';
import { ToastMsg } from '../../CommonFunctions/CommonFuntions';
import { State, City } from 'country-state-city';
import { Autocomplete, MenuItem, Select, TextField } from '@mui/material';
import { SEARCH_MOBILE } from '../../../Utility/Serviceurls';

const useOutsideClick = (ref, callback) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback]);
};

function UMAHospital() {
    const [birthdate, setBirthdate] = useState('');
    const [age, setAge] = useState('');
    const [name, setName] = useState('');
    const [title, setTitle] = useState('');
    const [gender, setGender] = useState('');
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [stateName, setStateName] = useState('TN');
    const [pincode, setPincode] = useState('');
    const [email, setEmail] = useState('');
    const [isNotEmailValid, setIsNotEmailValid] = useState(false);
    const [refSource, setrefSource] = useState('');
    const [otherReferal, setotherReferal] = useState('');
    const [showOthersTextarea, setShowOthersTextarea] = useState(false);
    const [showTerms, setShowTerms] = useState(false);
    const [agreeTerms, setAgreeTerms] = useState(false);
    const [isChecked, setisChecked] = useState(false);
    const [isDisable, setisDisable] = useState(false);
    const [errors, setErrors] = useState({});
    const [isErrorMsg, setIsErrorMsg] = useState(false);
    const [successMsg, setsuccessMsg] = useState(false);
    const [isErrorMsgText, setIsErrorMsgText] = useState('');
    const [successMsgText, setsuccessMsgText] = useState('');
    const [cityName, setCityName] = useState(City.getCitiesOfState("IN", "TN"));
    const AllStates = State.getStatesOfCountry("IN");
    const [showDropdown, setShowDropdown] = useState(false);
    const [filteredList, setFilteredList] = useState([]);
    const [lastSelectedPatient, setLastSelectedPatient] = useState(null);
    const dropdownRef = useRef(null);
    const [patientId, setPatientId] = useState(null)

    const today = new Date().toISOString().split('T')[0];

    useEffect(() => {
        setCityName(City.getCitiesOfState("IN", stateName))
        setCity("")
    }, [stateName])
    useEffect(() => {
        if (title == "Mr") {
            setGender("m");
        } else if (title == "Ms") {
            setGender("f");
        } else if (title == "Mrs") {
            setGender("f");
        }
        else {
            setGender("");
        }
    }, [title])
    const calculateAgeFromBirthdate = (birthdate) => {
        const birthdateDate = new Date(birthdate);
        const today = new Date();
        let calculatedAge = today.getFullYear() - birthdateDate.getFullYear();
        const monthDifference = today.getMonth() - birthdateDate.getMonth();

        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthdateDate.getDate())) {
            calculatedAge--;
        }
        if (calculatedAge <= 150 && calculatedAge >= 0) {
            setAge(calculatedAge);
        }
    };

    const calculateBirthdateFromAge = (inputAge) => {
        const today = new Date();
        today.setFullYear(today.getFullYear() - inputAge);

        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const yyyy = today.getFullYear();

        const formattedDate = `${dd}/${mm}/${yyyy}`;

        setBirthdate(formattedDate);
    };

    const handleFormattedDOBChange = (e) => {
        let value = e.target.value.replace(/\D/g, '');

    if (value.length === 0) {
        setBirthdate('');
        setAge('');
        return;
    }

    if (value.length >= 3 && value.length <= 4) {
        value = `${value.slice(0, 2)}/${value.slice(2)}`;
    } else if (value.length >= 5 && value.length <= 8) {
        value = `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4, 8)}`;
    }

    setBirthdate(value);
    setErrors((prevErrors) => ({ ...prevErrors, birthdate: '', age: '' }));

    if (value.length === 10) {
        const [day, month, year] = value.split('/');

        const isValidDate = (d, m, y) => {
            const date = new Date(y, m - 1, d);
            return (
                date &&
                date.getDate() === parseInt(d, 10) &&
                date.getMonth() + 1 === parseInt(m, 10) &&
                date.getFullYear() === parseInt(y, 10)
            );
        };

        if (isValidDate(day, month, year)) {
            const parsedDate = new Date(year, month - 1, day);
            calculateAgeFromBirthdate(parsedDate.toISOString().split('T')[0]);
        } else {
            setAge('');
        }
        } else {
            setAge('');
        }
    };


    const handleAgeChange = (event) => {
        const inputAge = event.target.value;

        if (inputAge === "") {
            setAge("");
            setBirthdate("");
        } else {
            const ageNumber = parseInt(inputAge);
            if (ageNumber >= 0 && ageNumber <= 150) {
                setAge(ageNumber);
                calculateBirthdateFromAge(ageNumber);
            }
        }
        setErrors((prevErrors) => ({ ...prevErrors, age: '', birthdate: '' }));
    };

    const handleAddressChange = (event) => {
        const inputName = event.target.value;
        if (inputName.length <= 100) {
            setAddress(inputName);
        }
    }

    const handleOtherReferal = (event) => {
        const inputName = event.target.value;
        if (inputName.length <= 30) {
            setotherReferal(inputName);
        }
    }

    const handleNameChange = (event) => {
        const inputName = event.target.value;
        if (/^[a-zA-Z\s]*$/.test(inputName)) {
            if (inputName.length <= 50) {
                setName(inputName);
                setErrors((prevErrors) => ({ ...prevErrors, name: '' }));
            }
        }
    };

    const handlePhoneChange = (event) => {
        const inputPhone = event.target.value;
        if (/^\d{0,10}$/.test(inputPhone)) {
            setPhone(inputPhone);
            setErrors((prevErrors) => ({ ...prevErrors, phone: '' }));

            if (inputPhone.length === 10) {
                searchPatient(inputPhone);
            } else {
                setShowDropdown(false);
            }
        }
    };

    const searchPatient = (mobileno) => {
        try {
            
            get(`${SEARCH_MOBILE}?search_key=${mobileno}&clinic_id=${204}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setFilteredList(response.data?.data);
                        setShowDropdown(response.data?.data?.length > 0);
                    }
                })
                .catch((e) => {
                    if (e.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const handlePincodeChange = (event) => {
        const inputPincode = event.target.value;
        if (/^\d{0,6}$/.test(inputPincode)) {
            setPincode(inputPincode);
            setErrors((prevErrors) => ({ ...prevErrors, pincode: '' }));
        }
    };

    const handleGenderChange = (event) => {
        setGender(event.target.value);
        setErrors((prevErrors) => ({ ...prevErrors, Gender: '' }));
    };

    const handleSourceChange = (event) => {
        setShowOthersTextarea(false);
        if (event.target.value === refSource) {
            setrefSource("")
        } else {
            setrefSource(event.target.value);
        }
    };

    const validateEmail = (email) => {
        const emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return emailPattern.test(email);
    };

    const handleEmailChange = (event) => {
        const inputEmail = event.target.value;
        if (inputEmail?.length < 50) {
            setEmail(inputEmail);
        }
        // setIsNotEmailValid(validateEmail(inputEmail));
        setErrors((prevErrors) => ({ ...prevErrors, email: '' }));
    };

    const handleOthersCheckboxChange = () => {
        setShowOthersTextarea(!showOthersTextarea);
        setrefSource('')
    };

    const toggleTermsVisibility = () => {
        setShowTerms(!showTerms);
    };

    const handleAgreeTermsChange = (event) => {
        setAgreeTerms(event.target.checked);
        setisChecked(event.target.checked)
        setErrors((prevErrors) => ({ ...prevErrors, agreeTerms: '' }));
    };

    const convertDOBToPayloadFormat = (dob) => {
        if (!dob || !dob.includes('/')) return dob;
        const [day, month, year] = dob.split('/');
        if (day && month && year) {
            return `${year}-${month}-${day}`;
        }
        return dob;
    };

    const postPatientDetail = () => {
        let REGISTRATION_FORM_POST = 'fo/qr-appointment/registration/'
        try {
            let data = {
                "clinic_id": 10, // Rajesh Clinic
                "patient_name": name ? name : "",
                "gender": gender ? gender : "",
                "dob": birthdate ? convertDOBToPayloadFormat(birthdate) : null,
                "age": age ? age : 0,
                "address_line_1": address ? address : "",
                "city": city ? city : "",
                "state": stateName ? AllStates?.find((item) => (item.isoCode === stateName))?.name : "",
                "pincode": pincode ? pincode : "",
                "mobile_number": phone ? phone : "",
                "email": email ? email : null,
                'country': 'India',
                "referral_source": showOthersTextarea ? otherReferal : refSource,
                "title": title ? title : "",
                "patient_id": patientId || null,
            }
            post(REGISTRATION_FORM_POST, data)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setBirthdate("")
                        setAge("")
                        setName("")
                        setGender("")
                        setPhone("")
                        setAddress("")
                        setCity("")
                        setStateName("TN")
                        setPincode("")
                        setEmail("")
                        setrefSource("")
                        setShowOthersTextarea(false)
                        setShowTerms(false)
                        setAgreeTerms('')
                        setotherReferal('')
                        setisChecked(false)
                        setisDisable(false)
                        setTitle("")
                        setPatientId(null)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                        setisDisable(false)
                    } else {
                        errorMessage(error.message)
                        setisDisable(false)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
            setisDisable(false)
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const newErrors = {};
        setisDisable(true);

        const isValidDate = (dob) => {
        const [dd, mm, yyyy] = dob.split('/');
        const date = new Date(`${yyyy}-${mm}-${dd}`);
        return date instanceof Date && !isNaN(date);
        }
        

        // Name and title
        if (!name || !title) newErrors.name = 'Title & Name is required';

        // Gender
        if (!gender) newErrors.Gender = 'Please Select Gender';

        // DOB
        if (!birthdate) {
            newErrors.birthdate = 'Birth date is required';
        } else if (!isValidDate(birthdate)) {
            newErrors.birthdate = 'Invalid DOB. Use format DD/MM/YYYY.';
        } else {
            const [day, month, year] = birthdate.split('/');
            const dobDate = new Date(`${year}-${month}-${day}`);
            const today = new Date();

            if (dobDate > today) {
                newErrors.birthdate = 'DOB cannot be in the future';
            } else {
                const calculatedAge = today.getFullYear() - dobDate.getFullYear();
                if (calculatedAge > 150 || calculatedAge < 0) {
                    newErrors.birthdate = 'DOB results in invalid age';
                }
            }
        }

        // Age
        if (!age) newErrors.age = 'Age is required';

        // Address
        if (!address) newErrors.address = 'Please Enter Address';

        // City
        if (!city) newErrors.city = 'Please Select City';

        // State
        if (!stateName) newErrors.stateName = 'Please Select State';

         // Phone
        if (!phone) {
            newErrors.phone = 'Phone number is required';
        } else if (phone.length !== 10) {
            newErrors.phone = 'Invalid Mobile Number';
        }


        // Email
        if (isNotEmailValid && email !== "") {
            newErrors.email = 'Invalid E-mail';
        }

        // Referral
        if (showOthersTextarea && otherReferal === "") {
            newErrors.referal = "Enter Other Referral Field";
        }

        // Terms
        if (!agreeTerms) {
            newErrors.agreeTerms = 'Please agree to the terms and conditions';
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            postPatientDetail();
        } else {
            setisDisable(false);
            const firstErrorKey = Object.keys(newErrors)[0];
            const toastMsg = newErrors[firstErrorKey];
            errorMessage(toastMsg);
        }
    };

    const errorMessage = (message) => {
        setIsErrorMsg(true)
        setIsErrorMsgText(message)
    }

    const successMessage = (message) => {
        setsuccessMsg(true)
        setsuccessMsgText(message)
    }

    const msgClose = () => {
        setIsErrorMsg(false)
        setIsErrorMsgText('')
        setsuccessMsg(false)
        setsuccessMsgText('')
    }

    const handleSelectPatient = (item) => {
        const ageMatch = item?.patient_age?.match(/^(\d+)Y/);
        const age = ageMatch ? ageMatch[1] : '';
        const date = new Date(item?.dob ? item?.dob : (item?.approx_dob || ''));
        const [year, month, day] = (item?.dob ? item?.dob : (item?.approx_dob || '')).split("-");
        setBirthdate(`${day}/${month}/${year}`)
        setName(item?.first_name || '');
        setGender(item?.patient_gender === 'Male' ? 'm' : item?.patient_gender === 'Female' ? 'f' : item?.patient_gender === 'TransGender' ? 't' : '')
        setAge(age || '')
        setAddress(item?.address_line_1 || '')
        setCity(item?.city__city_name || '')
        setPincode(item?.pincode || '')
        setShowDropdown(false);
        calculateAgeFromBirthdate(item?.dob)
        setPatientId(item.patient_id);
        setTitle(item?.title)
        setLastSelectedPatient({
            name: item?.first_name || '',
            phone: phone || '',
            age: age || '',
            gender: item?.patient_gender === 'Male' ? 'm' : item?.patient_gender === 'Female' ? 'f' : item?.patient_gender === 'TransGender' ? 't' : '',
            birthdate: `${day}/${month}/${year}`
        });
    };
    useEffect(() => {
        if (patientId !== null && lastSelectedPatient) {
            const hasNameChanged = name !== lastSelectedPatient.name;
            const hasPhoneChanged = phone !== lastSelectedPatient.phone;
            const hasageChanged = age !== lastSelectedPatient.age;
            const hasgenderChanged = gender !== lastSelectedPatient.gender;
            const hasbirthdateChanged = birthdate !== lastSelectedPatient.birthdate;

            if (hasNameChanged || hasPhoneChanged || hasageChanged || hasgenderChanged || hasbirthdateChanged) {
                setPatientId(null); // Clear ID if fields are edited
            }
        }
    }, [name, phone, gender, age, birthdate]);
    useOutsideClick(dropdownRef, () => {
        if (showDropdown) setShowDropdown(false);
    });
    return (
        <div className="formpage container" data-testid="eMed_formpage">
            <div className="header" data-testid="eMed_header">
                <img src={ImagePaths.UMAHeaderImage} alt="Header" data-testid="eMed_headerImage" />
            </div>
            <form onSubmit={handleSubmit} className="formpagedetails" data-testid="eMed_form">
                <div className="phonenum" data-testid="eMed_phonenum">
                    <div className="Heading">
                        <label className="label" data-testid="eMed_phoneLabel">Phone Number *</label><br />
                        {errors.phone && <p className="error" data-testid="eMed_phoneError">{errors.phone}</p>}
                    </div>
                    <div className="countrycodediv" style={{ display: 'flex', alignItems: 'center' }}>
                        <span className="country-code">+91</span>
                        <input
                            type="text"
                            value={phone}
                            onChange={handlePhoneChange}
                            data-testid="eMed_phoneInput"
                            style={{ flex: 1, paddingLeft: '8px' }}
                        />
                    </div>
                    {/* 🔽 Dropdown Suggestions */}
                    {showDropdown && (
                        <div ref={dropdownRef} style={{
                            position: 'absolute',
                            top: '80px',
                            left: 0,
                            right: 0,
                            background: '#fff',
                            border: '1px solid #ccc',
                            maxHeight: '150px',
                            overflowY: 'auto',
                            zIndex: 1000
                        }}>
                            {filteredList.map((item, idx) => (
                                <div
                                    key={idx}
                                    onClick={() => handleSelectPatient(item)}
                                    style={{
                                        padding: '8px',
                                        cursor: 'pointer',
                                        borderBottom: '1px solid #eee',
                                        backgroundColor: '#f9f9f9',
                                    }}
                                >
                                    <strong>{item.first_name || '-'}, {item.patient_age || '-'}</strong>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <div className="name" data-testid="eMed_name">
                    <div style={{ width: '100px', flexShrink: 0 }}>
                        <div className="Heading">
                            <label className="label" data-testid="eMed_nameLabel">Title *</label>
                        </div>
                        <div className="Input-Container">
                            <select
                                sx={{
                                    height: '35px',
                                    fontSize: '14px',
                                }}
                                style={{ width: '100%' }}
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                className="title-select"
                                data-testid="eMed_nameTitle"
                            >
                                <option value="">Select</option>
                                <option value="Dr">Dr</option>
                                <option value="Mr">Mr</option>
                                <option value="Ms">Ms</option>
                                <option value="Mrs">Mrs</option>
                                <option value="Master">Master</option>
                                <option value="Baby">Baby</option>
                                <option value="Baby of">Baby of</option>
                                <option value="Child">Child</option>
                            </select>
                        </div>
                    </div>
                    <div style={{ flex: 1 }}>
                        <div className="Heading">
                            <label className="label" data-testid="eMed_nameLabel">Enter your Name *</label>
                            {errors.name && <p className="error" data-testid="eMed_nameError">{errors.name}</p>}
                            {errors.title && <p className="error" data-testid="eMed_titleError">{errors.title}</p>}
                        </div>
                        <div className="Input-Container">
                            <input
                                type="text"
                                value={name}
                                style={{ width: '100%' }}
                                onChange={handleNameChange}
                                data-testid="eMed_nameInput"
                                maxLength={32}
                            />
                        </div>
                    </div>
                </div>

                <div className="Gender" data-testid="eMed_gender" style={{width: '48.2%' }}>
                    <div className="Heading">
                        <label className="label" data-testid="eMed_genderLabel">Gender *</label>
                        {errors.Gender ? <p className="error" data-testid="eMed_genderError">{errors.Gender}</p> : null}
                    </div>
                    <div className="optionsofsex" data-testid="eMed_genderOptions">
                        <label style={{ marginLeft: "-0.2vw" }}>
                            <input type="radio" name="yoursex" value="m" checked={gender === 'm'} onChange={handleGenderChange} data-testid="eMed_genderMale" />
                            <div className="label" style={{ marginLeft: "0.25vw" }}>Male</div>
                        </label>
                        <label style={{ marginLeft: '2vw' }}>
                            <input type="radio" name="yoursex" value="f" checked={gender === 'f'} onChange={handleGenderChange} data-testid="eMed_genderFemale" />
                            <div className="label" style={{ marginLeft: "0.25vw" }}>Female</div>
                        </label>
                        <label style={{ marginLeft: '2vw' }}>
                            <input type="radio" name="yoursex" value="t" checked={gender === 't'} onChange={handleGenderChange} data-testid="eMed_genderOther" />
                            <div className="label" style={{ marginLeft: "0.25vw" }}>Other</div>
                        </label>
                    </div>
                </div>

                <div className="dob" data-testid="eMed_dob">
                    <div className="Heading">
                        <label className="label" data-testid="eMed_dobLabel">DOB *</label><br />
                        {errors.birthdate ? <p className="error" data-testid="eMed_dobError">{errors.birthdate}</p> : null}
                    </div>
                    <div className="Input-Container">
                        <input
                            type="text"
                            inputMode='numeric'
                            pattern="\d{2}/\d{2}/\d{4}"
                            value={birthdate}
                            onChange={handleFormattedDOBChange}
                            data-testid="eMed_dobInput"
                            placeholder="DD/MM/YYYY"
                            maxLength={10}
                        />
                    </div>
                </div>

                <div className="age" data-testid="eMed_age">
                    <div className="Heading">
                        <label className="label" data-testid="eMed_ageLabel">Age *</label><br />
                        {errors.age && <p className="error" data-testid="eMed_ageError">{errors.age}</p>}
                    </div>
                    <div className="Input-Container">
                        <input type="number" value={age} onChange={handleAgeChange} data-testid="eMed_ageInput" />
                    </div>
                </div>
                <div className="address" data-testid="eMed_address">
                    <div className="Heading">
                        <label className="label" data-testid="eMed_addressLabel">Address* <br /></label>
                        {errors.address && <p className="error" data-testid="eMed_ageError">{errors.address}</p>}
                    </div>
                    <div className="Input-Container">
                        <textarea value={address} onChange={handleAddressChange} data-testid="eMed_addressInput"></textarea>
                    </div>
                </div>
                <div className="city">
                    <div className="Heading">
                        <label className="label" data-testid="eMed_cityLabel">City* <br /></label>
                        {errors.city && <p className="error" data-testid="eMed_ageError">{errors.city}</p>}
                    </div>
                    <div className="Input-Container">
                        <Autocomplete
                            size="small"
                            options={cityName ? cityName : []}
                            getOptionLabel={(option) => typeof (option) === "string" ? option : option.name}
                            onChange={(e, value) => {
                                setCity(value?.name ? value?.name : '',)
                            }}
                            clearIcon={false}
                            value={city}
                            renderInput={(params) => (
                                <TextField
                                    autoComplete="off"
                                    InputProps={{ ...params.InputProps }}
                                    onChange={(e) => setCity(e.target.value)}
                                    {...params}
                                />)}
                            onKeyDown={(e) => e.key === "Enter" ? e.preventDefault() : null}
                        />
                    </div>
                </div>
                <div className="state">
                    <div className="Heading">
                        <label className="label" data-testid="eMed_addressLabel">State* <br /></label>
                        {errors.stateName && <p className="error" data-testid="eMed_ageError">{errors.stateName}</p>}
                    </div>
                    <div className="Input-Container">
                        <Select
                            fullWidth
                            labelId='gender-select-label'
                            size="medium"
                            label={"State*"}
                            value={stateName}
                            onChange={(e) => {
                                setStateName(e.target.value)
                            }}
                            sx={{
                                height: '45px', // match other input height
                                fontSize: '14px',
                                borderRadius: '5px',
                                boxSizing: 'border-box',
                                '& .MuiSelect-select': {
                                    padding: '10px',
                                },
                            }}
                        >
                            {
                                AllStates?.map((list) => (
                                    <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>
                                ))
                            }
                        </Select>
                    </div>
                </div>
                <div className="pincode">
                    <div className="Heading">
                        <label className="label" data-testid="eMed_pincodeLabel">Pincode </label><br />
                        {/* {errors.pincode && <p className="error" data-testid="eMed_pincodeError">{errors.pincode}</p>} */}
                    </div>
                    <div className="Input-Container">
                        <input type="text" value={pincode} onChange={handlePincodeChange} data-testid="eMed_pincodeInput" />
                    </div>
                </div>

                

                <div className="emailid" data-testid="eMed_emailid">
                    <div className="Heading">
                        <label className="label" data-testid="eMed_emailLabel">Email ID</label><br />
                        {isNotEmailValid && email && <p className="error" data-testid="eMed_emailError">Please enter a valid email address.</p>}
                    </div>
                    <div className="Input-Container">
                        <input type="email" value={email} onChange={handleEmailChange} className={!isNotEmailValid ? 'valid' : 'invalid'} data-testid="eMed_emailInput" />
                    </div>
                </div>

                <div className="howdidu" data-testid="eMed_howdidu">
                    <p className="howdidupara" data-testid="eMed_howdiduPara">How did you hear about our hospital?</p>
                    <div className="checkboxlist">
                        <div className="source">
                            <input type="radio" id="s10health" value="S10Health" checked={refSource === 'S10Health'} onChange={handleSourceChange} onClick={handleSourceChange} data-testid="eMed_howdiduS10Health" />
                            <label className="label" htmlFor="s10health"> S10health</label>
                        </div>
                        <div className="source">
                            <input type="radio" id="newspaper" value="Newspaper" checked={refSource === 'Newspaper'} onChange={handleSourceChange} onClick={handleSourceChange} data-testid="eMed_howdiduNewspaper" />
                            <label className="label" htmlFor="newspaper"> Newspaper</label>
                        </div>
                        <div className="source">
                            <input type="radio" id="eyecamp" value="Eyecamp" checked={refSource === 'Eyecamp'} onChange={handleSourceChange} onClick={handleSourceChange} data-testid="eMed_howdiduEyeCamp" />
                            <label className="label" htmlFor="eyecamp"> Eye Camp</label>
                        </div>
                        <div className="source">
                            <input type="radio" id="website" value="Website" checked={refSource === 'Website'} onChange={handleSourceChange} onClick={handleSourceChange} data-testid="eMed_howdiduWebsite" />
                            <label className="label" htmlFor="website"> Website</label>
                        </div>
                        <div className="source">
                            <input type="radio" id="friends" value="Friends" checked={refSource === 'Friends'} onChange={handleSourceChange} onClick={handleSourceChange} data-testid="eMed_howdiduFriends" />
                            <label className="label" htmlFor="friends"> Friends / Relatives</label>
                        </div>
                    </div>
                    <div className="source checkboxlast">
                        <input type="radio" id="others" value="others" checked={showOthersTextarea === true} onChange={handleOthersCheckboxChange} onClick={handleOthersCheckboxChange} data-testid="eMed_howdiduOthers" />
                        <label className="label" htmlFor="others"> Others</label>
                        {showOthersTextarea && <textarea value={otherReferal} onChange={handleOtherReferal} data-testid="eMed_howdiduOthersInput"></textarea>}
                    </div>
                    {errors.referal && otherReferal === "" ? <p className="error" data-testid="eMed_referalError">{errors.referal}</p> : null}
                </div>

                <div className="UMAthankyou" data-testid="eMed_UMAthankyou">
                    <p className="bold-text">"Your Vision, Our Priority"</p>
                    <p className="bold-text" style={{ marginTop: '1rem' }}>Thank you for Choosing UMA Eye Clinic</p>
                </div>

                <div className="termsandcondition" data-testid="eMed_termsandcondition">
                    <span className="tandcall">
                        <input type="checkbox" id="termsandcondition" checked={isChecked} name="termsandcondition" value="howdidyou" onChange={handleAgreeTermsChange} data-testid="eMed_termsCheckbox" />
                        <p className="termsandconditionshow" onClick={toggleTermsVisibility} data-testid="eMed_termsToggle"> Terms and Conditions {showTerms ? '▲' : '▼'}</p>
                    </span>
                    {showTerms && (
                        <p className="termspara label" data-testid="eMed_termsText">
                            I hereby state that the information provided above is correct. I acknowledge receipt of a copy of the patient's rights and responsibilities, which I have read.

                            I give my consent for an eye examination at Uma Eye Clinic. I have been informed about the highest safety standards followed by Uma Eye Clinic. However, I absolve the hospital management of any liability arising from unforeseen circumstances beyond the control of the hospital.

                            I further consent to the release of information from my medical records, if necessary, to relevant authorities in accordance with the rules and policies of the hospital.
                        </p>
                    )}
                    {errors.agreeTerms && <p className="erroragree" data-testid="eMed_termsError">{errors.agreeTerms}</p>}
                </div>

                <div className="submitbtn">
                    <input disabled={isDisable} type="submit" value="Submit" data-testid="eMed_submitButton" />
                </div>
            </form>
            <div className="Footer" data-testid="eMed_header">
                <img src={ImagePaths.UMAFooterImage} alt="Header" data-testid="eMed_headerImage" />
            </div>
            <div className="imagesall" data-testid="eMed_imagesall">
                <div className="emedlogo">
                    <span className="alreadypat" style={{ fontWeight: 'bold' }}><p data-testid="eMed_emedLogoText">Download EmedHub </p> To view your reports and bills</span>
                </div>
                <div className="appstoreandplaystore" data-testid="eMed_appstoreAndPlaystore">
                    <a href="https://apps.apple.com/us/app/emedhub/id6475773185?platform=iphone*" target="_blank" rel="nofollow" data-testid="eMed_appstoreLink"> <img src={ImagePaths.AppStore} alt="Header" data-testid="eMed_appstoreImage" /></a>
                    <a href="https://play.google.com/store/apps/details?id=com.emedhub.clinic&pcampaignid=web_share" target="_blank" rel="nofollow" className="playstore" data-testid="eMed_playstoreLink"> <img src={ImagePaths.PlayStore} alt="Header" data-testid="eMed_playstoreImage" /></a>
                </div>
            </div>
            {isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose}
                />
                : null}
        </div>
    );
}

export default UMAHospital;